import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      // Fire AddToCart pixel event before redirecting to payment
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    } else {
      // Default: scroll to the payment area (price + button)
      const paymentArea = document.getElementById('payment');
      if (paymentArea) {
        paymentArea.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`relative group w-full md:w-auto inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-white bg-gradient-to-r from-[#1A7A4A] to-[#228B57] rounded-xl shadow-[0_0_20px_rgba(26,122,74,0.3)] hover:shadow-[0_0_30px_rgba(26,122,74,0.5)] transition-shadow duration-300 ${className}`} data-id="element-1">
      <span className="mr-2" data-id="element-2">{text}</span>
      <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-3" />
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 rounded-xl pointer-events-none" data-id="element-4" />
    </motion.button>;
}